// The date ranges people ask for by name.
//
// Two kinds, and the difference matters. A "to date" range stops today, so it is a part-month;
// those are answered day by day from the order rows, which is exact but costs a little more than
// reading the monthly tables. The counted ranges are whole months, deliberately: "last 6 months"
// taken as 180 days back would end on a half-finished month, and that month's bar would read as
// a collapse when it is only incomplete.

const pad = (n) => String(n).padStart(2, '0');
export const toLocalDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const firstOf = (y, m) => new Date(y, m, 1);
const lastOf = (y, m) => new Date(y, m + 1, 0);

export function datePresets(today = new Date()) {
  const y = today.getFullYear(), m = today.getMonth(), d = today.getDate();
  const lastMonth = new Date(y, m - 1, 1);
  const lm = { y: lastMonth.getFullYear(), m: lastMonth.getMonth() };
  // the same day of last month, or its last day where there is no such date
  const lmtdEnd = new Date(lm.y, lm.m, Math.min(d, lastOf(lm.y, lm.m).getDate()));
  const fyStart = m >= 3 ? new Date(y, 3, 1) : new Date(y - 1, 3, 1);   // April to March
  const wholeMonthsBack = (n) => ({ from: firstOf(lm.y, lm.m - n + 1), to: lastOf(lm.y, lm.m) });

  return [
    { key: 'mtd',   label: 'This month to date', from: firstOf(y, m), to: today },
    { key: 'lmtd',  label: 'Last month to date', from: firstOf(lm.y, lm.m), to: lmtdEnd },
    { key: 'lm',    label: 'Last month',         from: firstOf(lm.y, lm.m), to: lastOf(lm.y, lm.m) },
    { key: 'm3',    label: 'Last 3 months',      ...wholeMonthsBack(3) },
    { key: 'm6',    label: 'Last 6 months',      ...wholeMonthsBack(6) },
    { key: 'm12',   label: 'Last 12 months',     ...wholeMonthsBack(12) },
    { key: 'fy',    label: 'This fiscal year',   from: fyStart, to: today },
  ];
}

